export default function setupEditor(editor) {
    editor.config.uploadImgServer = '/backend/bbs/upload-img.php';
    editor.config.uploadImgMaxSize = 1 * 1024 * 1024; // 最大 1M
    editor.config.uploadImgMaxLength = 1; // 一次最多上传 5 个图片
    editor.config.uploadFileName = 'image';

    editor.config.menus = [
        'head',
        'bold',
        'fontSize',
        'fontName',
        'italic',
        'underline',
        'strikeThrough',
        'indent',
        'foreColor',
        'backColor',
        'link',
        'list',
        'justify',
        'quote',
        'emoticon',
        'image',
        'table',
        'splitLine',
        'undo',
        'redo',
    ]

    editor.config.colors = [
        // 黑色       铅灰       银鼠       雾霜
        "#000000", "#606468", "#9C9996", "#D4D8DD",
        // 大红       红鸢       蔷薇       樱花
        "#CC0022", "#F43333", "#F05570", "#EEA4AA",
        // 蜜柑       杏黄       向阳       柠檬
        "#EE7022", "#F49920", "#F0C010", "#F4E008",
        // 柳染       夏草       密林       碧玉
        "#AADD44", "#40CC10", "#108014", "#66C099",
        // 晴空       露草       薄缥       琉璃
        "#90D8EE", "#33AADD", "#2078A8", "#2430D8",
        // 绀青       桔梗       梦紫       菖蒲
        "#102070", "#7064B4", "#7730AA", "#C46CC0",
        // 桦茶       小豆       白橡       油纸
        "#663311", "#AA605A", "#DDAA88", "#E0CCB0",
    ]

    editor.config.emotions = [
        {
            title: 'qq', // tab 的标题
            type: 'image', // 'emoji' 或 'image' ，即 emoji 形式或者图片形式
            content: [
                {
                    "alt": "azgc",
                    "src": "/assets/emoij/qq/azgc.png"
                },
                {
                    "alt": "banzz",
                    "src": "/assets/emoij/qq/banzz.png"
                },
                {
                    "alt": "baojin",
                    "src": "/assets/emoij/qq/baojin.png"
                },
                {
                    "alt": "cb",
                    "src": "/assets/emoij/qq/cb.png"
                },
                {
                    "alt": "cg",
                    "src": "/assets/emoij/qq/cg.png"
                },
                {
                    "alt": "ch",
                    "src": "/assets/emoij/qq/ch.png"
                },
                {
                    "alt": "cs",
                    "src": "/assets/emoij/qq/cs.png"
                },
                {
                    "alt": "cy",
                    "src": "/assets/emoij/qq/cy.png"
                },
                {
                    "alt": "db",
                    "src": "/assets/emoij/qq/db.png"
                },
                {
                    "alt": "dgg",
                    "src": "/assets/emoij/qq/dgg.png"
                },
                {
                    "alt": "dk",
                    "src": "/assets/emoij/qq/dk.png"
                },
                {
                    "alt": "doge",
                    "src": "/assets/emoij/qq/doge.png"
                },
                {
                    "alt": "emm",
                    "src": "/assets/emoij/qq/emm.png"
                },
                {
                    "alt": "fad",
                    "src": "/assets/emoij/qq/fad.png"
                },
                {
                    "alt": "gg",
                    "src": "/assets/emoij/qq/gg.png"
                },
                {
                    "alt": "gz",
                    "src": "/assets/emoij/qq/gz.png"
                },
                {
                    "alt": "hhd",
                    "src": "/assets/emoij/qq/hhd.png"
                },
                {
                    "alt": "huaix",
                    "src": "/assets/emoij/qq/huaix.png"
                },
                {
                    "alt": "jk",
                    "src": "/assets/emoij/qq/jk.png"
                },
                {
                    "alt": "jy",
                    "src": "/assets/emoij/qq/jy.png"
                },
                {
                    "alt": "ka",
                    "src": "/assets/emoij/qq/ka.png"
                },
                {
                    "alt": "kel",
                    "src": "/assets/emoij/qq/kel.png"
                },
                {
                    "alt": "kk",
                    "src": "/assets/emoij/qq/kk.png"
                },
                {
                    "alt": "lb",
                    "src": "/assets/emoij/qq/lb.png"
                },
                {
                    "alt": "lengh",
                    "src": "/assets/emoij/qq/lengh.png"
                },
                {
                    "alt": "ll",
                    "src": "/assets/emoij/qq/ll.png"
                },
                {
                    "alt": "lyj",
                    "src": "/assets/emoij/qq/lyj.png"
                },
                {
                    "alt": "my",
                    "src": "/assets/emoij/qq/my.png"
                },
                {
                    "alt": "nkt",
                    "src": "/assets/emoij/qq/nkt.png"
                },
                {
                    "alt": "nqct",
                    "src": "/assets/emoij/qq/nqct.png"
                },
                {
                    "alt": "nzqk",
                    "src": "/assets/emoij/qq/nzqk.png"
                },
                {
                    "alt": "px",
                    "src": "/assets/emoij/qq/px.png"
                },
                {
                    "alt": "qd",
                    "src": "/assets/emoij/qq/qd.png"
                },
                {
                    "alt": "qiang",
                    "src": "/assets/emoij/qq/qiang.png"
                },
                {
                    "alt": "se",
                    "src": "/assets/emoij/qq/se.png"
                },
                {
                    "alt": "shuai",
                    "src": "/assets/emoij/qq/shuai.png"
                },
                {
                    "alt": "sl",
                    "src": "/assets/emoij/qq/sl.png"
                },
                {
                    "alt": "sr",
                    "src": "/assets/emoij/qq/sr.png"
                },
                {
                    "alt": "ts",
                    "src": "/assets/emoij/qq/ts.png"
                },
                {
                    "alt": "tt",
                    "src": "/assets/emoij/qq/tt.png"
                },
                {
                    "alt": "tuu",
                    "src": "/assets/emoij/qq/tuu.png"
                },
                {
                    "alt": "tyt",
                    "src": "/assets/emoij/qq/tyt.png"
                },
                {
                    "alt": "wn",
                    "src": "/assets/emoij/qq/wn.png"
                },
                {
                    "alt": "wq",
                    "src": "/assets/emoij/qq/wq.png"
                },
                {
                    "alt": "wul",
                    "src": "/assets/emoij/qq/wul.png"
                },
                {
                    "alt": "ww",
                    "src": "/assets/emoij/qq/ww.png"
                },
                {
                    "alt": "wx",
                    "src": "/assets/emoij/qq/wx.png"
                },
                {
                    "alt": "wzm",
                    "src": "/assets/emoij/qq/wzm.png"
                },
                {
                    "alt": "xia",
                    "src": "/assets/emoij/qq/xia.png"
                },
                {
                    "alt": "xjj",
                    "src": "/assets/emoij/qq/xjj.png"
                },
                {
                    "alt": "xk",
                    "src": "/assets/emoij/qq/xk.png"
                },
                {
                    "alt": "xyx",
                    "src": "/assets/emoij/qq/xyx.png"
                },
                {
                    "alt": "yb",
                    "src": "/assets/emoij/qq/yb.png"
                },
                {
                    "alt": "yiw",
                    "src": "/assets/emoij/qq/yiw.png"
                },
                {
                    "alt": "youl",
                    "src": "/assets/emoij/qq/youl.png"
                },
                {
                    "alt": "yt",
                    "src": "/assets/emoij/qq/yt.png"
                },
                {
                    "alt": "yun",
                    "src": "/assets/emoij/qq/yun.png"
                },
                {
                    "alt": "zy",
                    "src": "/assets/emoij/qq/zy.png"
                }
            ]
        },
    ]
}